export const LAG_TYPE_OPTIONS = [
  {
    label: 'Minimum',
    value: 'MINIMUM',
  },
  {
    label: 'Maintain',
    value: 'MAINTAIN',
  },
];
